import axios from "axios";
import API from "../helpers/api";
import { getCompanynameList, getShipnameList } from "./HelpersAPI";

export const getMmplDueList = (data) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MmplDueList}?mail=${user.email}&dueIn=${data.devicedueIn}&shipName=${data.ShipName}&PageNumber=${data.PageNumber}&PageSize=${data.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        
        dispatch({
          type: "GetMMPLDueListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLDueListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getMmplCompaniesList = (data) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MmplCompanyList}?mail=${user.email}&ClientId=${data.clientId??0}&PageNumber=${data.PageNumber}&PageSize=${data.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLCompaniesListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLCompaniesListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getMmplCompaniesListdidmount = (data) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MmplCompanyList}?mail=${user.email}&ClientId=${data.clientId??0}&PageNumber=${data.PageNumber}&PageSize=${data.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLCompaniesListSuccess",
          data: response.data,
        });
        dispatch(getShipnameList());
        dispatch(getCompanynameList());
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLCompaniesListFailure",
          error: "ERROR",
        });
      });
  };
};
